import { getStoreBuilder, BareActionContext } from 'vuex-typex';
import { RootState } from './index';
import { Marker } from '@/models/Retailer';

export interface MarkersState {
    markers: Marker[];
    retailer: Marker;
}

const initialState: MarkersState = {
    markers: {} as Marker[],
    retailer: {} as Marker
};

const store = getStoreBuilder<RootState>().module('markers', initialState);

// private getters
function getStoreMarkers(state: MarkersState): Marker[] {
    return state.markers;
}
function getStoreRetailer(state: MarkersState): Marker {
    return state.retailer;
}

// getters
const getMarkers = store.read(getStoreMarkers, 'getStoreMarkers');
const getRetailer = store.read(getStoreRetailer, 'getStoreRetailer');

// mutations:
function mutateSearchRetailer(state: MarkersState, payload: Marker[]): Promise<void> {
    return new Promise((resolve, reject) => {
        state.markers = payload;
        resolve();
    });
}
function mutateSetSelectedRetailer(state: MarkersState, payload: Marker): Promise<void> {
    return new Promise((resolve, reject) => {
        state.retailer = payload;
        resolve();
    });
}

// actions
async function saveSearchRetailer(
    context: BareActionContext<MarkersState, RootState>,
    payload: Marker[]
): Promise<void> {
    return await mutateSearchRetailer(context.state, payload);
}
async function saveSetSelectedRetailer(
    context: BareActionContext<MarkersState, RootState>,
    payload: Marker
): Promise<void> {
    return await mutateSetSelectedRetailer(context.state, payload);
}

// export store
export const MarkersStore = {
    searchRetailer: store.dispatch(saveSearchRetailer, 'saveSearchRetailer'),
    get getRetailer() {
        return getRetailer();
    },

    // Remove? Only used in uncommented code
    setSelectedRetailer: store.dispatch(saveSetSelectedRetailer, 'saveSetSelectedRetailer'),

    // Remove? Only used in uncommented code
    get getMarkers() {
        return getMarkers();
    }
};
